// src/config.js
const BASE_URL =
    process.env.REACT_APP_BASE_URL ||
    (process.env.NODE_ENV === "development" ?
        "/api" :
        "https://lmsapiadmin.initialinfinity.com/api");

export const STATIC_BASE_URL = BASE_URL.replace("/api", ""); // for static files
export {
    BASE_URL
};
export default BASE_URL;